const { config, version } = require("../../package.json");
// Environment config (config.<env>.js) and secrets.json are now resolved
// exclusively through the frontend SecretsManager facade.
const { getEnvironment, getTargetRegionConfig } = require("./SecretsManager");
let gitDisplayVersion;
try {
    gitDisplayVersion = require("cfg/version.json");
} catch {}

const defaultConfig = getEnvironment();
defaultConfig.backend = config.backend;
defaultConfig.environment = config.backend;
defaultConfig.isCloudDeployment = config.isCloudDeployment;
defaultConfig.version = gitDisplayVersion;
defaultConfig.serviceProfile = config.serviceProfile;
defaultConfig.semver = version;
defaultConfig.wsBaseUrl = `${defaultConfig.wsBaseUrl}/${config.serviceProfile}`;

if (!config.isCloudDeployment) {
    defaultConfig.AWS.oauth.redirectSignIn = "http://localhost:3000/";
    defaultConfig.AWS.oauth.redirectSignOut = "http://localhost:3000/signout";
    defaultConfig.wsBaseUrl = `ws://localhost:5100`;
    defaultConfig.microstrategy.mstrWebUrl =
        "http://localhost:8081/MicroStrategy/servlet/";
    // Reports V2 API Configuration
    defaultConfig.reportsV2ApiUrl = "http://localhost:9090/api";
}

defaultConfig.getTargetRegionConfig = getTargetRegionConfig;

// Reports V2 API Configuration (cb-revrec-report service)
// This is separate from the main repo API (services/api)
// Default port is 9090 (as configured in cb-revrec-report/api/src/config/index.ts)
defaultConfig.reportsV2ApiUrl =
    defaultConfig.reportsV2ApiUrl || "http://localhost:9090/api";

export default defaultConfig;
